const POLL_INTERVAL = 3000;

export default class AdminDataFrameworksPillarsIndex {

  constructor() {}

  render() {
    this.initProcessRatings();
    this.pollIfImporting();
  }

  initProcessRatings() {
    const btns = document.querySelectorAll('.js-process-ratings');
    if (!btns.length) return;

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        const url   = btn.dataset.url;
        const limit = btn.dataset.limit;

        btns.forEach((b) => { b.disabled = true; b.classList.add('disabled'); });

        const data = {};
        if (limit) data.limit = limit;

        $.ajax({
          type: 'POST',
          url:  url,
          data: data,
          headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
          complete: (result) => {
            if (result.status === 200 || result.status === 201) {
              this.showProgressBar(0);
              this.poll(btn.dataset.statusUrl);
            } else if (result.status === 409) {
              // already processing — just start polling
              this.poll(btn.dataset.statusUrl);
            } else {
              btns.forEach((b) => { b.disabled = false; b.classList.remove('disabled'); });
            }
          }
        });
      });
    });
  }

  pollIfImporting() {
    const bar = document.getElementById('ratingsProgressBar');
    if (!bar) return;

    const statusUrl = bar.dataset.statusUrl;
    this.poll(statusUrl);
  }

  poll(statusUrl) {
    $.ajax({
      type:     'GET',
      url:      statusUrl,
      dataType: 'json',
      complete: (result) => {
        if (result.status !== 200) return;

        const data     = JSON.parse(result.responseText);
        const percent  = Math.round((data.ratings_progress || 0) * 100);

        this.showProgressBar(percent);

        if (data.is_importing) {
          setTimeout(() => this.poll(statusUrl), POLL_INTERVAL);
        } else if (percent >= 100 || !data.is_importing) {
          this.onComplete();
        }
      }
    });
  }

  showProgressBar(percent) {
    let bar = document.getElementById('ratingsProgressBar');
    if (!bar) {
      // Create bar if it doesn't exist yet (job just kicked off)
      const container = document.querySelector('.fix-width.w-100.pt-3') || (() => {
        const el = document.createElement('div');
        el.className = 'fix-width w-100 pt-3';
        document.querySelector('.fix-width.w-100.mb-5') &&
          document.querySelector('.fix-width.w-100.mb-5').before(el);
        return el;
      })();

      container.innerHTML = `
        <div class="d-flex align-items-center mb-1">
          <small class="text-muted mr-2">Processing ratings…</small>
          <small class="text-muted js-ratings-progress-label">${percent}%</small>
        </div>
        <div class="progress w-100" style="height: 6px;" id="ratingsProgressBar">
          <div class="progress-bar js-ratings-bar" role="progressbar"
               style="width: ${percent}%;"
               aria-valuenow="${percent}" aria-valuemin="0" aria-valuemax="100">
          </div>
        </div>`;
      return;
    }

    const progressBar = bar.querySelector('.js-ratings-bar');
    if (progressBar) {
      progressBar.style.width = percent + '%';
      progressBar.setAttribute('aria-valuenow', percent);
    }
    const label = document.querySelector('.js-ratings-progress-label');
    if (label) label.textContent = percent + '%';
  }

  onComplete() {
    Turbo.visit(window.location.href);
  }

}
